module.exports = __webpack_public_path__ + "static/media/rosticceria profilo.1ff7302d.svg";